export default __webpack_public_path__ + "f00bc051912e94073d3b9a1c05f9b7b2.png";